module.exports = __webpack_public_path__ + "img/intelligentLightingSys.696f6bcb.svg";